import { FC } from "react";
import styles from "./FooterPage.module.scss";
import plus from "../../images/icons/plus_rose.svg";
import { text8 } from "./constants";

export const Agb: FC = () => {
  return (
    <div className={styles.infomation}>
      <div className={styles.infomation_conteiner}>
        <h2 className={styles.infomation__subtitle}>AGB</h2>
        <h1 className={styles.infomation__title}>Nutzungsbedingungen</h1>
      </div>
      <h3 className={styles.infomation_header}>1. Allgemeines</h3>
      <p className={styles.infomation_text}>
        Die nachfolgenden AGB regeln die Bedingungen zur Nutzung des Portals
        Termingirl.com (nachfolgend als „Termingirl“ bezeichnet) durch Besucher.
      </p>
      <h3 className={styles.infomation_header}>2. Dienste von Termingirl</h3>
      <p className={styles.infomation_text}>
        Termingirl stellt auf dem Portal Termingirl.com Inhalte gewerblicher
        Inserenten, beispielsweise Bordelle, Clubs, Modelle u.ä. zur Verfügung,
        die hiermit auf ihren Betrieb bzw. die von ihnen angebotenen
        Dienstleistungen aufmerksam machen können. Termingirl selbst ist nicht
        Anbieter der beworbenen Dienstleistungen.
      </p>
      <p className={styles.infomation_text}>
        Termingirl übernimmt keine Überprüfung der von den gewerblichen
        Inserenten veröffentlichten Inhalte und kann deshalb weder deren
        Richtigkeit, Angemessenheit oder Qualität gewährleisten. Termingirl kann
        Dienste, Funktionen und Inhalte der Website Termingirl.com jederzeit
        ändern, erweitern oder einschränken.
      </p>
      <h3 className={styles.infomation_header}>3. Besucher</h3>
      <p className={styles.infomation_text}>
        Volljährige Besucher haben die Möglichkeit, das Portal Termingirl.com
        kostenlos zu nutzen, um die hier veröffentlichten Inhalte zur Kenntnis
        zu nehmen und die Informationen zu privaten Zwecken zu verwenden. Eine
        gewerbliche Nutzung der Inhalte durch Besucher der Website ist
        untersagt.
      </p>
      <p className={styles.infomation_text}>
        Es besteht kein Rechtsanspruch auf die Nutzung der Dienste von
        Termingirl. Termingirl kann Besuchern gegenüber ein virtuelles
        Hausverbot aussprechen, diese also von einer künftigen Nutzung seiner
        Dienste ausschließen. Dies kommt insbesondere bei Verstößen gegen diese
        AGB, gesetzliche Bestimmungen oder bei dem Vorliegen sonstiger wichtiger
        Gründe in Betracht.
      </p>
      <h3 className={styles.infomation_header}>4. Rechte an der Datenbank</h3>
      <p className={styles.infomation_text}>
        Alle Rechte an dem Datenbankwerk, der Datenbank und den eingestellten
        Inhalten (bspw. Urheber-, Marken- und sonstige Schutzrechte) liegen
        ausschließlich bei Termingirl. Hiervon unberührt bleiben etwaige Rechte
        der Inserenten an den von ihnen eingestellten Inhalten. Besuchern ist es
        nicht gestattet, Kopien der Inserate, Fotografien, Videos zu erstellen
        und diese anderweitig zu veröffentlichen, öffentlich zugänglich zu
        machen oder zu verbreiten oder anderweitig zu verwenden. Entsprechendes
        gilt für Teile der Datensammlung oder die gesamte Datensammlung bzw.
        Datenbank.
      </p>
      <p className={styles.infomation_text}>
        Urheberrechtshinweise oder sonstige Schutzrechtsvermerke auf der Website
        von Termingirl dürfen nicht verändert werden.
      </p>
      <h3 className={styles.infomation_header}>5. Rechtsverletzungen</h3>
      <p className={styles.infomation_text}>
        Termingirl hat kein Interesse daran, dass Inhalte auf Termingirl.com die
        Rechte Dritter verletzen. Sollten Sie der Meinung sein, dass auf
        Termingirl.com Inhalte zu finden sind, die Ihre Rechte verletzen, bitten
        wir um Übermittlung der folgenden Informationen:
      </p>
      {text8.map((item, index) => (
        <div className={styles.infomation_list} key={index}>
          <img src={plus} alt="Icon not" className={styles.infomation_icon} />
          <p className={styles.infomation_text}>{item}</p>
        </div>
      ))}
      <p className={styles.infomation_text}>
        Meldung bitte per Mail an die im Impressum genannte Mailadresse. Wir
        werden allen ernsthaften Mitteilungen über Rechtsverletzungen
        unverzüglich nachgehen und die geeigneten rechtlichen Schritte
        einleiten. Jeglicher Missbrauch wird geahndet.
      </p>
      <h3 className={styles.infomation_header}>6. Datenschutz</h3>
      <p className={styles.infomation_text}>
        Termingirl nimmt den Datenschutz sehr ernst und verarbeitet
        personenbezogene Daten in Übereinstimmung mit den einschlägigen
        gesetzlichen Regelungen. Unsere Datenschutzerklärung finden Sie hier.
      </p>
    </div>
  );
};
